import { AxiosError } from 'axios';
import { QueryClient, UseQueryOptions, useQuery } from 'react-query';

import { GetDepositFilesResponse } from 'lib-ui/vv-uploader/vv-types';
import { useViewController } from 'lib-ui/vv-uploader/use-view-controller';

function useAgreementsDepositsFiles(
    depositId: number,
    options?: UseQueryOptions<GetDepositFilesResponse>
) {
    const viewController = useViewController();
    const queryClient = new QueryClient();

    return useQuery<GetDepositFilesResponse, AxiosError>(
        ['use-agreements-deposits-files', depositId],
        () => {
            return viewController
                .request({
                    path: `/api/v2/Deposit/${depositId}/files`,
                    method: 'GET',
                    secure: true,
                    format: 'json'
                })
                .then((response) => response.data)
                .catch((error) => {
                    if (error.response.status === 401) {
                        // Handle unauthorized error
                        console.error('Unauthorized access:', error);
                        queryClient.refetchQueries([
                            'use-request-token',
                            'start-upload-step-2'
                        ]);
                    }
                });
        },
        { retry: 2 }
    );
}

export default useAgreementsDepositsFiles;
